import {DmsRequest} from '../common/dms-request';
import {FunctionalHeader} from '../common/functional-header';
import {TechnicalHeaderInRequest} from '../common/technical-header-in-request';
import {UserInformation} from '../common/user-information';
import {SearchVehiclesRequestBody} from './search-vehicles-request-body';

export class SearchVehiclesRequest implements DmsRequest {
  readonly simpleName = 'search-vehicles';
  technicalHeader: TechnicalHeaderInRequest;
  functionalHeader: FunctionalHeader;
  userInformation: UserInformation;
  body: SearchVehiclesRequestBody;
}
